import { useQuery, useMutation } from "@tanstack/react-query";
import { disposalApiService } from "modules/Pharmacy/Disposal/api/disposal.api";
import { DisposalFormValues } from "modules/Pharmacy/Disposal/helpers/disposal.types";

interface ApiResponse<T = any> {
  data: T;
  message: string;
  statuscode: number;
}

export const useDisposalService = ({
  searchText,
  pageNumber = 1,
  pageSize,

  studyid,
  enableSelectall = false,
}: {
  searchText?: string | null;
  pageNumber?: number;
  pageSize?: number;

  studyid?: number | string | null;
  enableSelectall?: boolean;
} = {}) => {

  // SELECT ALL
  const SelectAllQuery = useQuery({
    queryKey: [
      "disposal-selectAll",
      { searchText, pageNumber, pageSize, studyid },
    ],
    queryFn: () =>
      disposalApiService.getSelectAllData({
        searchtext: searchText ?? null,
        currentpage: pageNumber,
        pagesize: pageSize,
        status: "A",
        studyid: studyid ?? null,
      }),
      enabled: enableSelectall,
  });

  // DELETE
  const DeleteMutation = useMutation<ApiResponse, Error, { disposalid: number | null, updatereason: string }>({
    mutationFn: (payload) =>
      disposalApiService.deleteData(payload),
  });

  // INSERT
  const InsertMutation = useMutation({
    mutationFn: (payload: DisposalFormValues) => disposalApiService.insertData(payload),
  });

  // UPDATE
  const UpdateMutation = useMutation({
    mutationFn: (payload: DisposalFormValues & { updatereason: string; }) => disposalApiService.updateData(payload),
  });

  // SELECT BY ID
  const SelectIdQuery = (disposalid: number | string | null) =>
    useQuery({
      queryKey: ["disposal-select", disposalid],
      queryFn: () => disposalApiService.getSelectData(disposalid!),
      enabled: !!disposalid,
    });

  const verifyPinMutation = useMutation({
    mutationFn: (payload: { verifypin: string, disposalid: number, studyid: number, verifiedby: number }) => disposalApiService.verifyPin(payload),
  });

  return { SelectAllQuery, InsertMutation, UpdateMutation, DeleteMutation, SelectIdQuery, verifyPinMutation };
};
